/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledLinkAvatar = styled.a`
    color: #2f80ed;
    font-size: 0.75rem;
    cursor: pointer;
`;
